export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["搜索"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您处于演示模式。余额和操作是练习用的。"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["转到工作台"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["未找到结果"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["仪表盘"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["我的商店"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["信息"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["新商店"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通知"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作历史"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["支持"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["交易对手信息"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AML检查"])}
}